'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactstrap = require('reactstrap');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AvFeedback = function (_Component) {
  (0, _inherits3["default"])(AvFeedback, _Component);

  function AvFeedback() {
    (0, _classCallCheck3["default"])(this, AvFeedback);
    return (0, _possibleConstructorReturn3["default"])(this, _Component.apply(this, arguments));
  }

  AvFeedback.prototype.render = function render() {
    var validation = this.context.Group.getInputState();
    return _react2["default"].createElement(_reactstrap.FormFeedback, (0, _extends3["default"])({
      valid: !validation.error
    }, this.props));
  };

  return AvFeedback;
}(_react.Component);

AvFeedback.propTypes = (0, _assign2["default"])({}, _reactstrap.FormFeedback.propTypes);
AvFeedback.contextTypes = {
  FormCtrl: _propTypes2["default"].object.isRequired,
  Group: _propTypes2["default"].object.isRequired
};
exports["default"] = AvFeedback;